import { render, staticRenderFns } from "./StatisticFilters.vue?vue&type=template&id=370acc98&"
import script from "./StatisticFilters.vue?vue&type=script&lang=js&"
export * from "./StatisticFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports